import Back from "../component/background/back"
import Cards from "../component/cards/card"
import Info from "../component/information/info"

function Services(){
    return(
        <>
    <Back/>
    <Cards/>
    <Info/>
    
        </>
    )
}
export default Services